import React from 'react';
import { Card, Table, Badge, Tabs, Tab, Button, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import moment from 'moment';
import { Link } from 'react-router-dom';

class AdminDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pendingApprovals: [],
            allRecords: {
                incoming: [],
                outgoing: [],
                inprogress: []
            },
            loading: false,
            activeTab: 'pending'
        };
    }

    componentWillMount() {
        this.fetchData();
    }

    fetchData = () => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user || !user.accountId) return;

        this.setState({ loading: true });

        // Fetch all pending approvals
        fetch(`${config.apiUrl}/getAllPendingApprovals?account_id=${user.accountId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                return response.text().then(text => {
                    if (!text || text.trim() === '') return [];
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        return [];
                    }
                });
            })
            .then(approvals => {
                this.setState({ pendingApprovals: approvals, loading: false });
            })
            .catch(error => {
                console.error('Error fetching pending approvals:', error);
                this.setState({ loading: false });
            });

        // Fetch all records for each type
        this.fetchAllRecords('incoming', user.accountId);
        this.fetchAllRecords('outgoing', user.accountId);
        this.fetchAllRecords('inprogress', user.accountId);
    }

    fetchAllRecords = (recordType, accountId) => {
        const endpoint = {
            'incoming': 'getIncomingSummaryByCompany',
            'outgoing': 'getOutgoingSummaryByCompany',
            'inprogress': 'getInprogressSummaryByCompany'
        }[recordType];

        if (!endpoint) return;

        fetch(`${config.apiUrl}/${endpoint}?company=${accountId}&keyword=&limit=1000&offset=0`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                return response.text().then(text => {
                    if (!text || text.trim() === '') return { data: [] };
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        return { data: [] };
                    }
                });
            })
            .then(result => {
                this.setState(prevState => ({
                    allRecords: {
                        ...prevState.allRecords,
                        [recordType]: result.data || []
                    }
                }));
            })
            .catch(error => {
                console.error(`Error fetching ${recordType} records:`, error);
            });
    }

    getStatusBadge = (status) => {
        switch(status) {
            case 0:
                return <Badge bg="warning">Pending</Badge>;
            case 1:
                return <Badge bg="success">Approved</Badge>;
            case 2:
                return <Badge bg="danger">Rejected</Badge>;
            default:
                return <Badge bg="secondary">Unknown</Badge>;
        }
    }

    getRecordTypeLabel = (type) => {
        const labels = {
            'incoming': 'Incoming Inspection',
            'outgoing': 'Outgoing Inspection',
            'inprogress': 'In-Progress Inspection'
        };
        return labels[type] || type;
    }

    getRecordTypeUrl = (type) => {
        const urls = {
            'incoming': '/incoming_summary',
            'outgoing': '/outgoing_summary',
            'inprogress': '/inprogress_summary'
        };
        return urls[type] || '#';
    }

    render() {
        const { pendingApprovals, allRecords, loading, activeTab } = this.state;

        return (
            <div className="container" style={{ marginTop: '20px' }}>
                <Card>
                    <Card.Header>
                        <h3>Admin Dashboard</h3>
                        <p className="text-muted">View all records and pending approvals</p>
                    </Card.Header>
                    <Card.Body>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => this.setState({ activeTab: k })}
                            className="mb-3"
                        >
                            <Tab eventKey="pending" title={`Pending Approvals (${pendingApprovals.length})`}>
                                {loading ? (
                                    <div className="text-center">Loading...</div>
                                ) : (
                                    <div style={{ marginTop: '20px' }}>
                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>Record Type</th>
                                                    <th>Record ID</th>
                                                    <th>Level</th>
                                                    <th>Pending Approver</th>
                                                    <th>Created At</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pendingApprovals.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">No pending approvals</td>
                                                    </tr>
                                                ) : (
                                                    pendingApprovals.map((approval, index) => (
                                                        <tr key={index}>
                                                            <td>{this.getRecordTypeLabel(approval.record_type)}</td>
                                                            <td>#{approval.record_id}</td>
                                                            <td>Level {approval.current_level}</td>
                                                            <td>
                                                                {approval.pendingApprover 
                                                                    ? `${approval.pendingApprover.firstName || ''} ${approval.pendingApprover.lastName || ''}`.trim() || approval.pendingApprover.username
                                                                    : 'N/A'
                                                                }
                                                            </td>
                                                            <td>
                                                                {approval.created_at 
                                                                    ? moment(approval.created_at).format('YYYY-MM-DD HH:mm:ss')
                                                                    : '-'
                                                                }
                                                            </td>
                                                            <td>
                                                                <Link 
                                                                    to={`${this.getRecordTypeUrl(approval.record_type)}`}
                                                                    className="btn btn-sm btn-primary"
                                                                >
                                                                    View
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </Tab>

                            <Tab eventKey="incoming" title={`Incoming (${allRecords.incoming.length})`}>
                                <div style={{ marginTop: '20px' }}>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Part No</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Lot No</th>
                                                <th>Lot Qty</th>
                                                <th>Defect Qty</th>
                                                <th>Status</th>
                                                <th>Approval Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allRecords.incoming.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10" className="text-center">No records found</td>
                                                </tr>
                                            ) : (
                                                allRecords.incoming.map((record, index) => (
                                                    <tr key={index}>
                                                        <td>{record.id}</td>
                                                        <td>{record.master ? record.master.partNo : '-'}</td>
                                                        <td>{record.master ? record.master.partDesc : '-'}</td>
                                                        <td>{moment(record.Timestamp).format('YYYY-MM-DD')}</td>
                                                        <td>{record.lotNo}</td>
                                                        <td>{record.lotQty}</td>
                                                        <td>{record.defectQty}</td>
                                                        <td>{record.approve_condition}</td>
                                                        <td>{this.getStatusBadge(record.approve_status)}</td>
                                                        <td>
                                                            <Link 
                                                                to={`/incoming_summary/${record.id}`}
                                                                className="btn btn-sm btn-primary"
                                                            >
                                                                View
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>

                            <Tab eventKey="outgoing" title={`Outgoing (${allRecords.outgoing.length})`}>
                                <div style={{ marginTop: '20px' }}>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Part No</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Job No</th>
                                                <th>Job Qty</th>
                                                <th>Defect Qty</th>
                                                <th>Status</th>
                                                <th>Approval Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allRecords.outgoing.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10" className="text-center">No records found</td>
                                                </tr>
                                            ) : (
                                                allRecords.outgoing.map((record, index) => (
                                                    <tr key={index}>
                                                        <td>{record.id}</td>
                                                        <td>{record.master ? record.master.partNo : '-'}</td>
                                                        <td>{record.master ? record.master.partDesc : '-'}</td>
                                                        <td>{moment(record.Timestamp).format('YYYY-MM-DD')}</td>
                                                        <td>{record.jobNo}</td>
                                                        <td>{record.jobQty}</td>
                                                        <td>{record.defectQty}</td>
                                                        <td>{record.approve_condition}</td>
                                                        <td>{this.getStatusBadge(record.approve_status)}</td>
                                                        <td>
                                                            <Link 
                                                                to={`/outgoing_summary/${record.id}`}
                                                                className="btn btn-sm btn-primary"
                                                            >
                                                                View
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>

                            <Tab eventKey="inprogress" title={`In-Progress (${allRecords.inprogress.length})`}>
                                <div style={{ marginTop: '20px' }}>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Part No</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Job No</th>
                                                <th>Job Qty</th>
                                                <th>Defect Qty</th>
                                                <th>Line/Machine</th>
                                                <th>Status</th>
                                                <th>Approval Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allRecords.inprogress.length === 0 ? (
                                                <tr>
                                                    <td colSpan="11" className="text-center">No records found</td>
                                                </tr>
                                            ) : (
                                                allRecords.inprogress.map((record, index) => (
                                                    <tr key={index}>
                                                        <td>{record.id}</td>
                                                        <td>{record.master ? record.master.partNo : '-'}</td>
                                                        <td>{record.master ? record.master.partDesc : '-'}</td>
                                                        <td>{moment(record.Timestamp).format('YYYY-MM-DD')}</td>
                                                        <td>{record.jobNo}</td>
                                                        <td>{record.jobQty}</td>
                                                        <td>{record.defectQty}</td>
                                                        <td>{record.linemachine}</td>
                                                        <td>{record.approve_condition}</td>
                                                        <td>{this.getStatusBadge(record.approve_status)}</td>
                                                        <td>
                                                            <Link 
                                                                to={`/inprogress_summary/${record.id}`}
                                                                className="btn btn-sm btn-primary"
                                                            >
                                                                View
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>
                        </Tabs>

                        <Row className="mt-4">
                            <Col>
                                <Button variant="secondary" onClick={this.fetchData}>
                                    Refresh Data
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default AdminDashboard;

